import { useEffect, useState } from 'react';
import CustomDialog from '../CustomDialog';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '@src/store/hooks';
// import profileImage from '@src/assets/images/profile.png';

function ProfileCheckModal({ orderMetadata }: { orderMetadata: any }) {
	const { profileCompletion } = orderMetadata || {};
	const [confirmDialog, setConfirmDialog] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const { id } = useParams();
	const defaultRestaurant: any = useAppSelector((state) => state?.restaurant?.value?.default);
	const { id: defaultRestaurantId } = defaultRestaurant || {};

	useEffect(() => {
		setConfirmDialog(!profileCompletion);
	}, [profileCompletion]);

	if (location.pathname !== `/restaurants/${id}`) {
		return null;
	}

	return (
		<CustomDialog
			open={confirmDialog}
			setOpen={setConfirmDialog}
			disable={false}
			description={`Your profile is not complete. Would you like to complete it now?`}
			handleClose={() => {
				setConfirmDialog(false);
			}}
			handleYes={() => {
				setConfirmDialog(false);
				navigate(`/restaurants/${id}/settings/branch?branchId=${defaultRestaurantId}`);
			}}
			// image={profileImage}
		/>
	);
}

export default ProfileCheckModal;
